<template>
  <button
    type="button"
    class="avatar-menu"
    :aria-label="word('shell.avatar.label')"
    aria-haspopup="dialog"
    :aria-expanded="menu.isOpen"
    data-avatar-menu
    @click="toggle"
  >
    <AvatarChip :initial="initial" :seed="seed" :size="32" />
  </button>
</template>

<script setup>
import { computed } from 'vue';
import { AvatarChip } from '@hds/auto-auction-com-components-shared';
import { sessionStore } from '@hds/identity-client-sdk';

import { useAppMenuStore } from './appMenuStore.js';
import { useShellWords } from './shellWords.js';

// The Avatar Menu: the signed-in person's avatar, as the button that opens the
// App Menu. It is the same opener on a phone and on a desktop. An app places it
// and passes nothing: who is signed in comes from the session, and it holds no
// reference to the drawer — both read the one App Menu store.

const menu = useAppMenuStore();
const session = sessionStore();
const word = useShellWords();

// Only the first letter of the name is shown. The seed is a stable key for the
// avatar's color — the person's id, not their name.
const initial = computed(() => (session.user?.displayName ?? session.user?.name ?? '').trim().charAt(0).toUpperCase());
const seed = computed(() => String(session.user?._id ?? session.user?.id ?? ''));

function toggle() {
    if (menu.isOpen) {
        menu.close();
        return;
    }
    menu.open();
}
</script>

<style scoped>
.avatar-menu {
  display: inline-grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
}

.avatar-menu:focus-visible {
  outline: 2px solid var(--p-primary-color);
  outline-offset: 2px;
}
</style>
